const uiSchema = () => ({
  address: {
    "ui:widget": "textarea",
  },
});

export default uiSchema;
